<main class="container-fluid">
  <section class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <!-- Titulo -->
    <div class="p-4 col-6">
      <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
      <label class="h5">Reporte de Productividad</label>
    </div>

    <!-- Botones Exportar y Filtro -->
    <div class="p-4 col-6 text-right">
      <button type="button" class="btn btn-outline-success mr-3" (click)="isExportar = !isExportar" [attr.aria-expanded]="!isExportar">Exportar</button>
      <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
        [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
        Ver filtros
      </button>
    </div>

    <!-- Configuracion Exportar -->
    <div id="exportar-form" class="col-12" *ngIf="!isExportar">
      <div class="card mb-3">
        <div class="card-body">
          <form [formGroup]="formExport" (submit)="exportDataReport()">
            <div class="row">
              <div class="col-3 mb-2 input-group-prepend" formArrayName="exportarList"
                *ngFor="let order of formExport.controls.exportarList.controls; let i = index">
                <div class="input-group-text mr-2">
                  <input type="checkbox" [formControlName]="i" name="checkExport" (change)="checkboxValidate()">
                </div>
                <label class="label label-primary medium" for="">{{exportarList[i].name}}</label>
              </div>
              <div class="col-4 mb-2 input-group-prepend">
                  <div class="input-group-text">
                    <input type="checkbox" formControlName="selectAll" (change)="checkboxValidate()">
                  </div>
                  <label class="label label-primary medium" for="">Seleccionar/Deseleccionar Todo</label>
                </div>
              <div class="col-12">
                <button class="btn btn-success m-auto" type="submit" [disabled]="isDisabled">Exportar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Filtros -->
    <div id="filtros" class="col-12" [ngbCollapse]="isCollapsed">
      <div class="card mb-3">
        <div class="card-body">
          <form [formGroup]="formFiltro" (submit)="filtrar()">
            <div class="row">
              <div class="col-2">
                <label class="small text-secondary" for="codigo_camara">Cámara de Comercio</label>
                  <select class="form-control form-control-sm" formControlName="codigo_camara">
                    <option value="" selected>Seleccione</option>
                    <option *ngFor="let option of listCamaraComercio"
                      value="{{option?.codigo_camara}}" [selected]="false">
                      {{option?.desc_camara}}
                    </option>
                  </select>
              </div>

              <div class="col-2">
                <label class="small text-secondary" for="tipo_solicitud_id">Tipo solicitud</label>
                <select class="form-control form-control-sm" formControlName="tipo_solicitud_id">
                  <option class="" value="" selected="true">
                    Seleccione
                  </option>
                  <option class="" *ngFor="let option of listTipoSolicitud; let i = index"
                    value="{{option?.tipo_solicitud_id}}" [selected]="false">
                    {{option?.descripcion}}
                  </option>
                </select>
              </div>

              <div class="col-2">
                <label class="small text-secondary" for="estado_solicitud_id">Estado solicitud</label>
                <select class="form-control form-control-sm" formControlName="estado_solicitud_id">
                  <option class="" value="" selected="true">
                    Seleccione
                  </option>
                  <option class="" *ngFor="let option of listEstadoSolicitud; let i = index"
                    value="{{option?.estado_solicitud_id}}" [selected]="false">
                    {{option?.descripcion}}
                  </option>
                </select>
              </div>

              <div class="col-2">
                <label class="small text-secondary" for="numero_radicado">Número radicado</label>
                <input type="text" class="form-control form-control-sm" formControlName="numero_radicado">
              </div>

              <div class="col-2">
                <label class="small text-secondary" for="funcionario">funcionario</label>
                <input type="text" class="form-control form-control-sm" formControlName="funcionario">
              </div>

              <div class="col-2">
                <label class="small text-secondary" for="codigo_rnt">RNT</label>
                <input type="text" class="form-control form-control-sm" formControlName="codigo_rnt">
              </div>

              <div class="col-2">
                <label class="small text-secondary" for="estado_rnt_id">Estado RNT</label>
                <select class="form-control form-control-sm" formControlName="estado_rnt_id">
                  <option class="" value="" selected="true">
                    Seleccione
                  </option>
                  <option class="" *ngFor="let option of listEstadoRnt; let i = index"
                    value="{{option?.estado_rnt_id}}" [selected]="false">
                    {{option?.descripcion}}
                  </option>
                </select>
              </div>

              <div class="col-2">
                <label class="small text-secondary" for="categoria_id">Categoría</label>
                <select class="form-control form-control-sm" formControlName="categoria_id">
                  <option class="" value="" selected="true">
                    Seleccione
                  </option>
                  <option class="" *ngFor="let option of listCategoria; let i = index"
                    value="{{option?.categoria_id}}" [selected]="false">
                    {{option?.descripcion}}
                  </option>
                </select>
              </div>

              <div class="col-2">
                <label class="small text-secondary" for="sub_categoria_id">Subcategoria</label>
                <select class="form-control form-control-sm" formControlName="sub_categoria_id">
                  <option class="" value="" selected="true">
                    Seleccione
                  </option>
                  <option class="" *ngFor="let option of listSubCategoriaFilter; let i = index"
                    value="{{option?.sub_categoria_id}}" [selected]="false">
                    {{option?.descripcion}}
                  </option>
                </select>
              </div>

              <div class="col-2">
                <label class="small text-secondary" for="matricula">Matricula</label>
                <input type="text" class="form-control form-control-sm" formControlName="matricula">
              </div>

              <div class="col-2">
                <label class="small text-secondary" for="codigo_departamento">Departamento</label>
                <select class="form-control form-control-sm" formControlName="codigo_departamento">
                  <option class="" value="" selected="true">
                    Seleccione
                  </option>
                  <option class="" *ngFor="let option of listDepartamentoFilter; let i = index"
                    value="{{option?.departamento_id}}" [selected]="false">
                    {{option?.descripcion}}
                  </option>
                </select>
              </div>

              <div class="col-2">
                <label class="small text-secondary" for="codigo_municipio">Municipio</label>
                <select class="form-control form-control-sm" formControlName="codigo_municipio">
                  <option class="" value="" selected="true">Seleccione</option>
                  <option class="" *ngFor="let option of listMunicipioFilter; let i = index"
                    value="{{option?.municipio_id}}" [selected]="false">
                    {{option?.descripcion}}
                  </option>
                </select>
              </div>

              <div class="col-2">
                <label class="small text-secondary" for="razon_social">Razon social</label>
                <input type="text" class="form-control form-control-sm" formControlName="razon_social">
              </div>

              <div class="col-2">
                <label class="small text-secondary" for="nit">NIT</label>
                <input type="text" class="form-control form-control-sm" formControlName="nit">
              </div>

              <div class="col-2 d-flex" style="align-items: center; justify-content: center;">
                <button type="submit" class="btn btn-primary mr-2">Filtrar</button>
                <button type="reset" class="btn btn-outline-primary">Limpiar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Data -->
    <div class="col-12">
      <div class="table-responsive">
        <app-tablas [page] = "paginaActual" [headers]="headerTabla"  (paginado)="onPaginado($event)" [sizeData]="dataTabla.paging.totalItems"
          class="table-responsive">
          <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
            <td>{{item.descripcion_camara}}</td>
            <td>{{item.descripcion_tipo_solicitud}}</td>
            <td>{{item.descripcion_estado_solicitud}}</td>
            <td>{{item.fecha_creacion  | date:'d/MMM/yyyy, h:mm a' }}</td>
            <td>{{item.numero_radicado}}</td>
            <td>{{item.fecha_radicacion  | date:'d/MMM/yyyy, h:mm a' }}</td>
            <td>{{item.nombre_funcionario}}</td>
            <td>{{item.fecha_ultima_actualizacion  | date:'d/MMM/yyyy, h:mm a' }}</td>
            <td>{{item.dias_gestion}}</td>
            <td>{{item.codigo_rnt}}</td>
            <td>{{item.descripcion_estado_rnt}}</td>
            <td>{{item.descripcion_categoria}}</td>
            <td>{{item.descripcion_subcategoria}}</td>
            <td>{{item.matricula}}</td>
            <td>{{item.descripcion_departamento}}</td>
            <td>{{item.descripcion_municipio}}</td>
            <td>{{item.razon_social}}</td>
            <td>{{item.nit}}</td>
            <td>{{item.nombre_representante_legal}}</td>
            <td>{{item.numero_identificacion_representante_legal}}</td>
          </tr>
        </app-tablas>
      </div>
    </div>
  </section>
</main>
